import {trackEvent} from '@hconnect/common/logging/Analytics'
import {EditNote} from '@mui/icons-material'
import {Button, useMediaQuery, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface ContinueWithMaterialVariationsButtonProps {
  materialId?: string
  onContinue: () => void
  testId?: string
}

export const ContinueWithMaterialVariationsButton: React.FC<
  ContinueWithMaterialVariationsButtonProps
> = ({materialId, onContinue, testId = 'continue-with-material-variations-button'}) => {
  const {t} = useTranslation()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClick = () => {
    // Track analytics event
    trackEvent('rmcStepMaterialVariations', {
      materialId,
      hasVariations: true,
      businessLine: 'RMC'
    })

    // Trigger parent callback
    onContinue()
  }

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      startIcon={<EditNote />}
      fullWidth
      size={isSmallScreen ? 'small' : 'medium'}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        lineHeight: '24px',
        borderColor: '#E8ECF0',
        color: '#29333D',
        backgroundColor: '#FFFFFF',
        fontFamily: 'Inter',
        '&:hover': {
          backgroundColor: '#F5F7F9',
          borderColor: '#D1D9E0'
        },
        '&:active': {
          backgroundColor: '#E6EEF5',
          borderColor: '#C1CDD9'
        },
        '@media (max-width: 320px)': {
          fontSize: '13px',
          padding: '8px 16px',
          minHeight: '40px'
        },
        '@media (max-width: 240px)': {
          fontSize: '10px',
          padding: '4px 8px',
          minHeight: '32px'
        }
      }}
      data-test-id={testId}
    >
      {t('orderIntake.rmc.steps.material.continueWithMaterialVariations')}
    </Button>
  )
}
